import { memo } from 'react';

import { cn } from '../../lib/styles';

type DividerProps = React.HTMLAttributes<HTMLDivElement>;

const DividerBase = ({ className, ...rest }: DividerProps) => {
  return <div className={cn('w-full bg-border-default h-px', className)} {...rest} />;
};

export const Divider = memo(DividerBase);
